import React, { useEffect, useState } from "react";

import { validateArrayIncludes } from "../../../common/validators";
import {
  ORDER_STATUS_DISPATCHABLE,
  ORDER_STATUS_FINISHABLE,
} from "../../../types/order";
import {
  getOrderCancelReason,
  getStatusNumberBackgroundColor,
  getStatusNumberColor,
} from "../../../utils/orders";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOrderThunk,
  finishOrderThunk,
  readyToPickupOrderThunk,
  setShowOrderInfosModal,
} from "../../../store/actions/ordersSlice";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import { ButtonPink, ButtonSuccessNoShadow } from "../../styled/button";
import { TextButtonLike } from "../../styled/typography";
// ICONS
import SendIcon from "@mui/icons-material/Send";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

export default function OrderModalActions({ order, loadOrder }) {
  const dispatch = useDispatch();

  const showOrderInfosModal = useSelector(
    (state) => state.orders.showOrderInfosModal
  );

  const [statusText, setStatusText] = useState(false);

  const getCancelEventDescription = () => {
    const cancelEvent = order?.events.find(
      (event) => event.code === "CAN" && event.reason
    );

    if (cancelEvent) {
      return ` - ${getOrderCancelReason(cancelEvent.reason) ?? ""}`;
    }

    return "";
  };

  useEffect(() => {
    const loadData = async () => {
      setStatusText(
        `${order?.status} ${
          order?.status_number === 377 ? getCancelEventDescription() : ""
        } ${
          order?.status_number === 5 && order?.order_type !== "TAKEOUT"
            ? `com ${order?.driverData?.name || "Motorista não detectado"}`
            : ""
        }`
      );
    };

    loadData();
  }, []);

  const handleOrderModal = () => {
    dispatch(
      setShowOrderInfosModal({
        orderId: undefined,
        show: !showOrderInfosModal,
      })
    );
  };

  const handleAcceptOrder = () => {
    dispatch(
      acceptOrderThunk({
        order,
      })
    );
    loadOrder();
  };

  const handleFinishOrder = () => {
    dispatch(finishOrderThunk({ order }));
    loadOrder();
  };

  const handleReadyOrder = () => {
    dispatch(readyToPickupOrderThunk({ order }));
    loadOrder();
  };

  return (
    <Box display="flex" alignItems="center">
      <TextButtonLike
        color={getStatusNumberColor(order?.status_number)}
        backgroundColor={getStatusNumberBackgroundColor(order?.status_number)}
        className="cashier-info-status-step"
        sx={{ mx: 1 }}
      >
        {statusText}
      </TextButtonLike>

      {order?.status_number === 0 && (
        <ButtonSuccessNoShadow
          startIcon={<ThumbUpIcon />}
          onClick={handleAcceptOrder}
        >
          Aceitar
        </ButtonSuccessNoShadow>
      )}

      {order?.order_type === "TAKEOUT" &&
        validateArrayIncludes(
          ORDER_STATUS_DISPATCHABLE,
          order?.status_number
        ) && (
          <ButtonPink endIcon={<SendIcon />} onClick={handleReadyOrder}>
            Pronto Para Retirar
          </ButtonPink>
        )}

      {order?.channel === "SLAPIE_POS" &&
        validateArrayIncludes(
          ORDER_STATUS_FINISHABLE,
          order?.status_number
        ) && (
          <ButtonSuccessNoShadow
            endIcon={<SendIcon />}
            onClick={handleFinishOrder}
          >
            Fechar Pedido
          </ButtonSuccessNoShadow>
        )}
    </Box>
  );
}
